import type { AuthenticationPort } from '@/domains/auth/AuthenticationPort'
import { UserPreferencesPort } from '@/domains/user-preference/UserPreferencePort'

export let authPort: AuthenticationPort
export let userPreferencesPort: UserPreferencesPort

export const setAuthPort = (adapter: AuthenticationPort) => {
  authPort = adapter
}

export const setUserPreferencesPort = (adapter: UserPreferencesPort) => {
  userPreferencesPort = adapter
}
